export const WALLET_DETAILS_CONFIG = {
  DEFAULT_PAGE_SIZE: 10,
  INITIAL_PAGE: 0,
} as const;

export const WALLET_TOOLTIPS = {
  removeFavorite: () => $localize`:@@removeFavorites:Eliminar de Favoritos`,
  addFavorite: () => $localize`:@@addFavorite:Agregar a Favoritos`,
  deleteWallet: () => $localize`:@@deleteWallet:Excluir Carteira`,
  editWallet: () => $localize`:@@editWallet:Editar Carteira`,
} as const;

export const DELETE_WALLET_TEXTS = {
  title: () => $localize`:@@WalletDeletionTitle:Eliminación de cartera`,
  message: (walletName: string) =>
    $localize`:@@ConfirmWalletDeletion:¿Confirmar la eliminación de la cartera ${walletName}?`,
  confirmButtonText: () => $localize`:@@deleteWallet:Eliminar cartera`,
};
